document.addEventListener("DOMContentLoaded", function() {

    let isSyncing = false;
    let lastSyncTime = 0;
    
    function logWithTime(message, ...args) {
        const time = performance.now().toFixed(2);
        console.log(`⏱️ ${time}ms - ${message}`, ...args);
    }

    function triggerSync(source = "") {
        const now = Date.now();

        if (now - lastSyncTime < 1000) {
            logWithTime("⛔ Blocked duplicate sync from: " + source);
            return;
        }

        lastSyncTime = now;
        syncCart(source);
    }

    function syncCart(source) {
        theme.partials.Cart.updateAllHtml(function() {
            logWithTime("Add to cart complete ✅");
        });

        theme.partials.Cart.updateAllHasItems(1, true);
         logWithTime("Data cart");
        if (isSyncing) return;

        isSyncing = true;
        logWithTime("🛒 Syncing cart from: " + source);

        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                logWithTime("✅ Cart synced");

                if (window.theme?.partials?.Cart) {
                    theme.partials.Cart.updateAllHtml(function() {
                        logWithTime("Add to cart complete ✅");
                    });

                    if (theme.partials.Cart.updateAllHasItems) {
                        theme.partials.Cart.updateAllHasItems(cart.item_count, true);
                    }
                }

                document.querySelectorAll('.cart-count').forEach(el => {
                    el.textContent = cart.item_count;
                });
            })
            .finally(() => {
                isSyncing = false;
            });
    }

    const drawer = document.querySelector('.off-canvas--viewport.appco_bg');

    if (drawer) {
        let lastState = null;

        new MutationObserver(() => {
            const state = drawer.getAttribute("data-off-canvas--state");

            if (state !== lastState) {
                lastState = state;

                if (state === "right-open") {
                    logWithTime("🎯 Drawer opened");
                    triggerSync("drawer");
                }
            }
        }).observe(drawer, {
            attributes: true,
            attributeFilter: ['data-off-canvas--state']
        });
    }
    const btn = document.querySelector('.product-form-product-template.button');
    btn.style.setProperty('display', 'block', 'important');
    btn.disabled = true;
    new MutationObserver((mutations) => {
        for (let m of mutations) {

            if (m.type === "childList" && m.addedNodes.length > 0) {

                m.addedNodes.forEach(node => {
                    if (!(node instanceof HTMLElement)) return;

                    // direct match
                    if (node.matches?.('.ES-button-FBT span') && !node.dataset.synced) {
                        node.dataset.synced = "true";

                        logWithTime("🔥 ES-button-FBT added (direct)");
                        triggerSync("fbt");
                    }

                });

            }
        }
    }).observe(document.body, {
        childList: true,
        subtree: true
    });


    const showButton = () => {
        const btns = document.querySelector('#m-1616711294508 .product-form-product-template.button');
            console.log("🌍 Page fully loaded");
            setTimeout(() => {
                btns.style.setProperty('display', 'block', 'important');
                btns.disabled = false;
                console.log("✅ Button enabled after load + 5s");
            }, 1000);
    };
    const module = document.querySelector('[data-name="Frequently Bought Ecomstar"]');
    if(module){
        const fbt = document.querySelector('.ES-button-FBT span');
    }
   
    if(module){
        // observe DOM
        new MutationObserver((mutations, observer) => {
            const fbt = document.querySelector('.ES-button-FBT span');
            if (fbt) {
                showButton();
                observer.disconnect(); // stop observing after found
            }

        }).observe(document.body, {
            childList: true,
            subtree: true
        });
    }else{
        showButton();
        return;
    }

});